import 'PackWerkNurikaeSite/pages/companies/index/partials/clamp_text_with_link/component.scss'

// 元テキストの保存
const saveOriginalText = (element, textElement) => {
  if (!element.dataset.originalText) {
    element.dataset.originalText = textElement.textContent.trim()
  }
}

// 要素をリセット
const resetElement = (element, textElement, moreLink, originalText, clampSize) => {
  element.style.setProperty('--clamp-size', clampSize)
  textElement.textContent = originalText
  moreLink.classList.remove('clamp-text-with-link__more-link--show')
}

// 最適な文字数を二分探索で見つける
const findOptimalLength = (element, textElement, moreLink, originalText) => {
  let left = 0
  let right = originalText.length
  let bestLength = 0

  while (left <= right) {
    const mid = Math.floor((left + right) / 2)

    textElement.textContent = originalText.substring(0, mid) + '•••'
    moreLink.classList.add('clamp-text-with-link__more-link--show')

    if (element.scrollHeight <= element.offsetHeight) {
      bestLength = mid
      left = mid + 1
    } else {
      right = mid - 1
    }
  }

  return bestLength
}

// 単一要素の処理
const processElement = (element) => {
  const textElement = element.querySelector('.js-clampTextWithLinkText')
  const moreLink = element.querySelector('.clamp-text-with-link__more-link')
  const clampSize = parseInt(element.dataset.clampSize) || 3

  saveOriginalText(element, textElement)
  const originalText = element.dataset.originalText

  resetElement(element, textElement, moreLink, originalText, clampSize)

  if (element.scrollHeight > element.offsetHeight) {
    const bestLength = findOptimalLength(element, textElement, moreLink, originalText)
    textElement.textContent = originalText.substring(0, bestLength) + '•••'
    moreLink.classList.add('clamp-text-with-link__more-link--show')
  }
}

// テキスト省略コンポーネント初期化
const initClampTextWithLink = () => {
  const clampTextWithLinks = document.querySelectorAll('.clamp-text-with-link:not([data-clamp-initialized])')
  clampTextWithLinks.forEach(element => {
    element.dataset.clampInitialized = 'true'
    processElement(element)
  })
}

// 初期ロード時
document.addEventListener('DOMContentLoaded', initClampTextWithLink)

// 遅延読み込み対応: MutationObserverで新しい要素を監視
const observer = new MutationObserver(() => {
  initClampTextWithLink()
})

observer.observe(document.body, {
  childList: true,
  subtree: true
})

// リサイズ時に再実行（デバウンス付き）
let resizeTimer
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => {
    // リサイズ時は全要素を再処理
    document.querySelectorAll('.clamp-text-with-link').forEach(element => {
      delete element.dataset.clampInitialized
    })
    initClampTextWithLink()
  }, 100)
})
